import React from 'react';
import styles from './SectionHeader.module.scss';
import Icon from '../icons/Icon';

function SectionHeader(props) {
    const {className = '', next, color, children} = props;

    return (
        <h2 className={[styles.SectionHeader, className, next ? 'has-icon-right' : null, 'unmargin-right'].join(' ')} style={{color}}>
            {children}
            {next ? <Icon className={styles.iconRight} src="/img/arrow_event@3x.png" color={color} /> : null}
        </h2>
    );
}

export default SectionHeader;
